module.exports = __webpack_public_path__ + "static/media/SOP.a610572a.pdf";